import CompleteProfileBlock from './CompleteProfileBlock';
import { CompleteProfileBlockProps, CompleteProfileBlockValueProps } from './types';

export type { CompleteProfileBlockProps, CompleteProfileBlockValueProps };
export default CompleteProfileBlock;
